<p *ngIf="fieldDescription" class="mb-0 mt-2">
  {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
</p>
<mat-form-field
  *ngIf="!readonly"
  class="w-100"
  [floatLabel]="floatLabel"
  [ngClass]="{ 'allow-pointer': tooltipText, 'no-label': hideLabel }"
>
  <mat-label>
    {{ labelOverride || fgInfo?.label
    }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-label>
  <input
    #input
    type="text"
    matInput
    [placeholder]="placeholder"
    [required]="fgInfo.required"
    [formControl]="formControl"
    [matAutocomplete]="autoGroup"
    [maxLength]="fgInfo.maxLength"
    [attr.aria-label]="hideLabel ? fieldDescription : labelOverride || fgInfo.label"
    [attr.data-automation-id]="dataAutomationId"
    (click)="onInputClick($event)"
    (keydown)="onInputKeyDown($event)"
    (ngModelChange)="onInputValueUpdate($event)"
  />
  <mat-autocomplete
    #autoGroup="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onChange()"
    (closed)="validateSelection()"
  >
    <mat-option
      *ngIf="allowNullSelection"
      [ngClass]="{ 'd-none': !alwaysShowAutocomplete && !showAutocomplete }"
    >
      -Begin Typing-
    </mat-option>
     @for (option of filteredOptions | async; track option) {
       <mat-option
         [value]="option.value"
         [attr.data-automation-id]="dataAutomationId"
         [ngClass]="{ 'd-none': !alwaysShowAutocomplete && !showAutocomplete }"
       >
         {{ option.name }}
       </mat-option>
     }
  </mat-autocomplete>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="errorDefinitions?.length">
    <ng-container *ngFor="let errorDefinition of errorDefinitions">
      <span *ngIf="formControl?.touched && errorDefinition.showFunction() && errorDefinition.errorMessage(formControl)"> {{ errorDefinition.errorMessage(formControl) }}</span>
    </ng-container>
  </mat-error>
  <!-- <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error> -->
  <mat-error *ngIf="formControl.touched && formControl.hasError('notValidOption')">
    {{ invalidValueErrorMessage }}
  </mat-error>
</mat-form-field>
<ng-container *ngIf="readonly">
  <mat-form-field
    class="no-underline w-100"
    floatLabel="always"
    [ngClass]="{ 'read-only': readonly, 'allow-pointer': tooltipText, 'no-label': hideLabel }"
  >
    <mat-label>
      {{ labelOverride || fgInfo?.label }}
      <mat-icon
        [hidden]="!tooltipText"
        [matTooltip]="tooltipText"
        [matTooltipPosition]="'after'"
        [attr.aria-label]="'Tooltip: ' + tooltipText"
      >
        help
      </mat-icon>
    </mat-label>
    <input
      readonly
      matInput
      [attr.data-automation-id]="dataAutomationId"
      [value]="currentSelection"
      tabindex="-1"
    />
  </mat-form-field>
</ng-container>
